<script setup lang="ts">
const props = defineProps<{
    pickedQuantity: number
}>()

</script>

<template>
    <div class="star-display-container">
        <div class="star-display-container__stars">
            <svg 
                v-for="i in props.pickedQuantity" 
                :key="i" 
                width="20px" 
                height="20px" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                class="star-svg star-filled"
            >
                <rect width="24" height="24" />
                <path
                    d="M11.5245 4.46353C11.6741 4.00287 12.3259 4.00287 12.4755 4.46353L13.9084 8.87336C13.9753 9.07937 14.1673 9.21885 14.3839 9.21885H19.0207C19.505 9.21885 19.7064 9.83866 19.3146 10.1234L15.5633 12.8488C15.3881 12.9761 15.3148 13.2018 15.3817 13.4078L16.8145 17.8176C16.9642 18.2783 16.437 18.6613 16.0451 18.3766L12.2939 15.6512C12.1186 15.5239 11.8814 15.5239 11.7061 15.6512L7.95488 18.3766C7.56303 18.6613 7.03578 18.2783 7.18546 17.8176L8.6183 13.4078C8.68524 13.2018 8.61191 12.9761 8.43667 12.8488L4.68544 10.1234C4.29358 9.83866 4.49497 9.21885 4.97933 9.21885H9.6161C9.83272 9.21885 10.0247 9.07937 10.0916 8.87336L11.5245 4.46353Z"
                    stroke="#ffe018" 
                    stroke-linecap="round" 
                    stroke-linejoin="round" 
                />
            </svg>
        </div>
    </div>
</template>

<style lang="scss">
@import "../../styles/core/variables.scss";

.star-display-container__stars {
    display: flex;
    align-items: center;
    gap: 2px;
}

.star-svg {
    transition: none;
    cursor: default;
}


.star-svg path {
    stroke: var(--scheme-yellow);
    fill: var(--scheme-yellow);
}

.star-filled path {
    fill: $scheme-yellow;
    stroke: $scheme-yellow;
}
</style>
